import {UpdateAdminComponent} from "./update-admin.component";

export default UpdateAdminComponent
